export default {
  computed: {},
  methods: {},
};
